import request from '@/utils/request'
import store from '@/store'
import axios from 'axios'


const url = store.getters.getPostUrl;
export default {
  // selectEquipmentById(param) {
  //   return request({
  //     url: store.getters.getPostUrl + '/mes/signal/selectEquipmentById',
  //     method: 'post',
  //     params: param
  //   })
  // },
  selectDataEventList(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentMonitoringService/selectDataEventList',
      method: 'post',
      data: param
    })
  },
  update(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentMonitoringService/update',
      method: 'put',
      data: param
    })
  },
  selectEquipmentById(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentMonitoringService/selectEquipmentAll',
      method: 'post',
      data: param
    })
  },
  statusType() {
    return request({
      url: store.getters.getPostUrl + 'mes/dict/ByDictIdALL?dictId=101',
      method: 'get'
    })

  },
  getWorkTime() {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentMonitoringService/selectTime',
      method: 'get'
    })


  },
  selectDataEventExcel(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentMonitoringService/excel',
      method: 'post',
      data: param
    })
  },


  selectTime(param, beginTime, endTime, code) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentMonitoringService/selectDataEvent?beginTime=' + beginTime + '&endTime=' + endTime + '&code=' + code,
      method: 'post',
      data: param
    })
  },

  selectEquipmentAll(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentMonitoringService/selectEquipmentAll',
      method: 'post',
      data: param
    })
  },
  selectDayPie(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentMonitoringService/dayPie',
      method: 'post',
      data: param
    })
  },
  selectMonth(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/KPI/selectDetailOperativeDay',
      method: 'post',
      data: param
    })
  },
  selectYear(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/KPI/selectDetailOperative',
      method: 'post',
      data: param
    })
  },

  // getFactoryTypeList() {
  //   return request({
  //     url: store.getters.getPostUrl + 'mes/dict/ByDictIdALL?dictId=1',
  //     method: 'get'
  //   })
  // },

}



// WEBPACK FOOTER //
// ./src/assets/js/signal/equipmentMonitoringService.js